// extracted by mini-css-extract-plugin
export var container = "_da-0";